var _rect, _rect2, _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSegmentError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 132,
    viewBox: "0 0 122 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 122,
    height: 132,
    fill: "#F5F5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 6497",
    x: -1349,
    y: -2834,
    width: 9921,
    height: 6609,
    stroke: "#FF0000",
    strokeWidth: 54
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000005533"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000005406"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 6348",
    filter: "url(#filter0_d_1342_5895)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -568,
    y: -113,
    width: 834,
    height: 371,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -567.5,
    y: -112.5,
    width: 833,
    height: 370,
    rx: 5.5,
    stroke: "#EBE8F1"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000006108"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2124632606992"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.8 34.1V3.59998L3 34.1H28.8Z",
    fill: "#BC92C2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M105.8 132V117.4C105.2 117.8 104.5 118.2 103.9 118.5V130.1H1.9V36H30.7V1.9H103.8V63C104.5 63.3 105.1 63.7 105.7 64.1V0H29.3L0 34.8V132H105.8ZM3 34.1L28.8 3.6V34.1H3Z",
    fill: "#3E004A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18 43.9H72.7C73.2 43.9 73.7 44.3 73.7 44.9C73.7 45.4 73.3 45.9 72.7 45.9H18C17.5 45.9 17 45.5 17 44.9C17 44.4 17.5 43.9 18 43.9Z",
    fill: "#3E004A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18 55.4H64C64.5 55.4 65 55.8 65 56.4C65 56.9 64.6 57.4 64 57.4H18C17.5 57.4 17 57 17 56.4C17 55.8 17.5 55.4 18 55.4Z",
    fill: "#3E004A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M18 66.8H34.4C34.9 66.8 35.4 67.2 35.4 67.8C35.4 68.3 35 68.8 34.4 68.8H18C17.5 68.8 17 68.4 17 67.8C17 67.2 17.5 66.8 18 66.8Z",
    fill: "#3E004A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M18 78.2H51.9C52.4 78.2 52.9 78.6 52.9 79.2C52.9 79.7 52.5 80.2 51.9 80.2H18C17.5 80.2 17 79.8 17 79.2C17 78.7 17.5 78.2 18 78.2Z",
    fill: "#3E004A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M89.1998 58.4C98.0998 58.4 106.2 62 112.1 67.9C118 73.8 121.6 81.9 121.6 90.8C121.6 99.7 118 107.8 112.1 113.7C106.2 119.6 98.0998 123.2 89.1998 123.2C80.2998 123.2 72.1998 119.6 66.2998 113.7C60.3998 107.8 56.7998 99.7 56.7998 90.8C56.7998 81.9 60.3998 73.8 66.2998 67.9C72.1998 62 80.2998 58.4 89.1998 58.4ZM110.7 69.3C105.2 63.8 97.5998 60.4 89.1998 60.4C80.7998 60.4 73.1998 63.8 67.6998 69.3C62.1998 74.8 58.7998 82.4 58.7998 90.8C58.7998 99.2 62.1998 106.8 67.6998 112.3C73.1998 117.8 80.7998 121.2 89.1998 121.2C97.5998 121.2 105.2 117.8 110.7 112.3C116.2 106.8 119.6 99.2 119.6 90.8C119.6 82.4 116.2 74.8 110.7 69.3Z",
    fill: "#3E004A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M85.2998 105.1C85.2998 107.3 87.0998 109.1 89.2998 109.1C91.4998 109.1 93.2998 107.3 93.2998 105.1C93.2998 102.9 91.4998 101.1 89.2998 101.1C86.9998 101.1 85.2998 102.9 85.2998 105.1ZM91.0998 105.1C91.0998 106.1 90.2998 107 89.1998 107C88.1998 107 87.2998 106.2 87.2998 105.1C87.2998 104.1 88.0998 103.2 89.1998 103.2C90.2998 103.2 91.0998 104 91.0998 105.1ZM89.1998 72.5C88.5998 72.5 88.1998 73 88.1998 73.5V94.5C88.1998 95.1 88.6998 95.5 89.1998 95.5C89.6998 95.5 90.1998 95 90.1998 94.5V73.5C90.2998 72.9 89.7998 72.5 89.1998 72.5Z",
    fill: "#3E004A"
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000006119"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 6497_2",
    x: -1358,
    y: -2865,
    width: 9921,
    height: 6609,
    stroke: "#FF0000",
    strokeWidth: 54
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1342_5895",
    x: -589,
    y: -118,
    width: 876,
    height: 413,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1342_5895"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1342_5895",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSegmentError);
export default __webpack_public_path__ + "static/media/SegmentError.4aa80ebed0a58f476c49cf602af6402d.svg";
export { ForwardRef as ReactComponent };